<template>
  <div>
    <div v-if="loading.fetch" class="w-100">
      <v-skeleton-loader type="image" class="mt-10" :tile="true" />
      <v-row class="mt-5">
        <v-col></v-col>
        <v-col class="mod-details">
          <v-skeleton-loader
            type="heading"
            style="margin: 0 auto"
            :tile="true"
          />
          <v-skeleton-loader type="sentences@3" class="mt-5" :tile="true" />
        </v-col>
        <v-col></v-col>
      </v-row>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col>
          <v-skeleton-loader type="heading" :tile="true" />
        </v-col>
        <v-col cols="1"></v-col>
        <v-col>
          <v-skeleton-loader type="heading" :tile="true" />
          <v-row>
            <v-col>
              <v-skeleton-loader type="text" :tile="true" />
            </v-col>
            <v-col>
              <v-skeleton-loader type="text" :tile="true" />
            </v-col>
            <v-col>
              <v-skeleton-loader type="text" :tile="true" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-skeleton-loader type="image" :tile="true" />
    </div>
    <div v-else>
      <div class="w-100">
        <v-breadcrumbs class="pl-0" :items="breadCrumbsItems" divider=">" />
      </div>
      <v-card color="#ffffff">
        <!-- <div class="container" v-if="module.thumbnail">
            <v-img
              class="white--text"
              v-if="
                includes(
                  imageFileTypes,
                  module.thumbnail
                    ? module.thumbnail.split('.').slice(-1).toString()
                    : false
                )
              "
              :src="module.thumbnail"
              width="100%"
              height="100%"
            >
            </v-img>
            <div v-else class="embed-responsive embed-responsive-21by9">
              <iframe
                title=""
                :id="'module-page-intro-video-build-' + module.id"
                class="embed-responsive-item"
                :src="bannerUrl"
                allowfullscreen
              ></iframe>
            </div>
            <v-btn
              class="mt-1"
              v-if="isEdit"
              x-small
              color="primary"
              @click="toggleUploadFileDialog"
            >
              Edit Thumbnail
            </v-btn>
            <div class="row" v-show="false">
              <div class="col-lg-12 text-center">
                <v-btn
                  text
                  color="primary"
                  :disabled="module.intro_video_watched"
                  @click="markAsWatched(module.id)"
                  v-if="
                    module.thumbnail
                      ? module.thumbnail.split('.').slice(-1).toString() !==
                          'jpg' &&
                        module.thumbnail.split('.').slice(-1).toString() !==
                          'png' &&
                        module.thumbnail.split('.').slice(-1).toString() !==
                          'webp'
                      : true
                  "
                >
                  Mark as Watched
                </v-btn>
              </div>
            </div>
          </div> -->
        <!-- <div class="container" v-if="isEdit && !module.thumbnail">
            <v-img
              v-if="canEdit(module.company_id)"
              class="white--text unit-image"
              src="https://webinarinc-v2-development.s3-us-west-2.amazonaws.com/categories/4/36168a56b2741b3b52045c4e0ea4165c.jpg"
              width="100%"
              height="100%"
              gradient="to top right, rgba(0,0,0,.70), rgba(25,32,72,.7)"
              @click="toggleUploadFileDialog"
            >
              <v-container fill-height fluid>
                <v-row align="center" justify="center">
                  <v-col align="center" class="headline">
                    Add Video/Image Thumbnail
                  </v-col>
                </v-row>
              </v-container>
            </v-img>
          </div> -->
        <!-- end of 1st video -->
        <div :id="'client-lms__module-' + $vnode.key">
          <div class="p-5 text-left" height="unset">
            <div class="float-right d-inline">
              <v-btn
                color="primaryMain"
                class="primaryMainText--text"
                @click="toggleEditMode"
                small
                right
                v-if="canEdit(module.company_id)"
                elevation="0"
              >
                <i class="fal fa-edit mr-2" />
                Edit
              </v-btn>
            </div>
            <div class="w-100">
              <v-text-field
                label=""
                v-model="module.name"
                ref="input"
                hide-details
                dense
                @change="changeOrder"
                prepend-inner-icon="fa-lightbulb"
                class="d-inline"
                v-if="isEdit"
              />
              <h1 v-else class="text-uppercase font-weight-bold module-title">
                <i class="fal fa-lightbulb"></i>
                <v-tooltip right class="w-25">
                  <template #activator="{ on }">
                    <span v-on="on" class="subtitle-1 w-25">
                      About this module
                    </span>
                  </template>
                  <span>A module can house hundreds of series and videos</span>
                </v-tooltip>
                <br />
                {{ module.name }}
              </h1>
              <word-editor
                :getMyData="module.description"
                :inputChange="changeOrder"
                :secondValue.sync="module.description"
                v-model="module.description"
                v-if="isEdit"
              />
              <p v-else v-html="module.description" class="lead mt-10"></p>
              <!-- start of buttons -->
              <div
                class="d-flex flex-wrap justify-content-left justify-content-md-start w-100"
              >
                <div v-show="module.links.length !== 0">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <div v-on="on">
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-show="!isEdit"
                              color="primaryMain"
                              class="ms-2 primaryMainText--text"
                              text
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon class="mr-2" small> fal fa-link </v-icon>
                              Related Links
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(link, index) in module.links"
                              :key="index"
                            >
                              <v-list-item-title>
                                <v-tooltip top>
                                  <template #activator="{ on }">
                                    <v-btn
                                      block
                                      text
                                      v-on="on"
                                      :href="link.url"
                                      target="_blank"
                                      color="light-blue darken-1"
                                      class="ms-2 white--text"
                                    >
                                      {{ link.name }}
                                    </v-btn>
                                  </template>
                                  <span>{{ link.url }}</span>
                                </v-tooltip>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                    <span>Related Links</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-btn
                        v-show="isEdit"
                        v-on="on"
                        @click="toggleLinksDialog"
                        text
                        color="primaryMain"
                        class="ms-2 primaryMainText--text"
                      >
                        <v-icon class="mr-2" small> fal fa-link </v-icon>
                        Related Links
                      </v-btn>
                    </template>
                    <span>Click to open Edit Related Links</span>
                  </v-tooltip>
                </div>
                <div v-show="isEmpty(module.links)">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-btn
                        v-show="isEdit"
                        v-on="on"
                        @click="toggleLinksDialog"
                        text
                        color="primary"
                        class="ms-2 white--text"
                      >
                        <v-icon class="mr-2" small> fal fa-link </v-icon>
                        Add Related Links
                      </v-btn>
                    </template>
                    <span>Click to open Edit Related Links</span>
                  </v-tooltip>
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      class="ms-2 white--text"
                      @click.stop="showShareModule = true"
                      text
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon right dark class="mr-2">fal fa-share-alt</v-icon
                      >Share Module
                      <share-module
                        :module_id="module.id"
                        v-model="showShareModule"
                      />
                    </v-btn>
                  </template>
                  <span> Share the whole module to your team. </span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      class="ms-2 white--text"
                      @click.stop="showAssignModule = true"
                      text
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon right dark class="mr-2">fal fa-users</v-icon
                      >Assign Module
                      <assign-module
                        :module_id="module.id"
                        v-model="showAssignModule"
                      />
                    </v-btn>
                  </template>
                  <span> Assign the whole module to your team. </span>
                </v-tooltip>
              </div>
              <!-- end of buttons -->
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <!-- start of progress bar -->
                  <label class="mb-0 mr-0 mr-sm-2 mr-md-3">
                    <b>Module Progress:</b>
                  </label>
                  <v-progress-linear
                    :value="module.module_progress"
                    color="#9AA4B2"
                    height="20"
                    striped
                    rounded
                  >
                    <template v-slot="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                  <p class="subtitle-2">
                    This progress bar updates whenever you
                    <strong>watch or complete</strong> a unit in this module.
                    <span v-if="checkProgressChange">
                      <br />
                      New Content Added. You were certified last:
                      <strong>{{
                        module.user_certificate.created_at | displayDateTime
                      }}</strong>
                    </span>
                  </p>
                  <!-- end of progress bar -->
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="search"
                    label="Search units in the module"
                    prepend-icon="fal fa-search"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="3"
                  v-if="!isEmpty(module.my_assigned)"
                >
                  <h3 class="subtitle-1">
                    <i class="fal fa-calendar-star"></i>
                    This module has been assigned to you<br />
                    <span class="ml-5"> Due Date: {{ dueDate }} </span>
                  </h3>
                </v-col>
                <v-col cols="12" sm="12" md="3" v-else></v-col>
                <v-col cols="12" sm="12" md="9"> </v-col>
              </v-row>
            </div>
          </div>
          <v-btn
            block
            text
            class="p-5 addSeries mb-2 px-5 headline"
            elevation="2"
            @click="toggleAddSeriesDialog"
            v-if="canEdit(module.company_id)"
            color="#555555"
            ><v-icon class="mr-2">fa-light fa-plus</v-icon> Add Series</v-btn
          >
        </div>
        <!-- start of units divider -->

        <v-expansion-panels
          :value="0"
          class="px-5"
          focusable
          accordion
          :key="key"
        >
          <draggable
            :list="module.series"
            :disabled="!isEdit"
            @change="changeOrder"
            @start="dragging = true"
            @end="dragging = false"
            class="row"
            :options="{ animation: 200, group: 'status' }"
            :element="'div'"
            v-model="module.series"
          >
            <v-expansion-panel
              v-for="(series, index) in module.series"
              :key="series.id"
            >
              <v-btn
                v-if="isEdit"
                @click="deleteSeries(series)"
                absolute
                top
                right
                small
                elevation="2"
                fab
              >
                <i class="fal fa-trash" color="#ff5252" />
              </v-btn>
              <v-expansion-panel-header
                :class="series.is_banner ? 'banner' : ''"
                :style="
                  series.is_banner
                    ? 'min-height: 200px; background-image:url(' +
                      renderBanner(series).thumbnail +
                      '); background-position:center; background-repeat:no-repeat; background-size:cover;'
                    : ''
                "
              >
                <template v-slot:actions>
                  <div class="w-100" v-if="isEdit">
                    <v-btn
                      class="pulsing d-inline primaryMainText--text"
                      color="primaryMain"
                      @click.native.stop="editSeries(series)"
                      small
                      elevation="0"
                    >
                      <i class="fal fa-edit mr-2" />
                      Edit
                    </v-btn>
                    &nbsp;
                  </div>
                  <div v-else>
                    <v-tooltip
                      top
                      v-if="series.user_progress.units_left == '0'"
                    >
                      <template #activator="{ on }">
                        <div v-on="on">
                          <v-menu offset-y>
                            <template #activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                style="border: 1px solid #f9b417"
                                dark
                                text
                                v-bind="attrs"
                                v-on="on"
                                @click.native.stop=""
                              >
                                Certificate
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="primary"
                                      class="white--text"
                                      @click.native.stop="
                                        downloadCertificate(series.id)
                                      "
                                      text
                                      x-small
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon right dark class="mr-2"
                                        >fal fa-download</v-icon
                                      >
                                      Download Certificate
                                    </v-btn>
                                  </template>
                                  <span>
                                    Download Your Series Certificate.
                                  </span>
                                </v-tooltip>
                              </v-list-item>
                              <v-list-item>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="primary"
                                      class="white--text"
                                      @click.native.stop="
                                        resendCertificate(series.id)
                                      "
                                      text
                                      x-small
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon right dark class="mr-2"
                                        >fal fa-paper-plane</v-icon
                                      >
                                      Re-send Certificate
                                    </v-btn>
                                  </template>
                                  <span>
                                    Resend Certificate To Your Email.
                                  </span>
                                </v-tooltip>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>
                      <span>Click to Download Certificate</span>
                    </v-tooltip>
                    <v-btn v-else disabled> Certificate </v-btn>
                  </div>
                </template>
                <v-row style="width: 100%" align="left" justify="left">
                  <v-col cols="12" sm="12" md="1" lg="1" xl="1">
                    <v-tooltip
                      v-if="series.user_progress.units_left == '0'"
                      right
                    >
                      <template #activator="{ on }">
                        <v-icon v-on="on" color="success">
                          fas fa-badge-check
                        </v-icon>
                      </template>
                      <span
                        >Download or Resend your Certificate on the Certificate
                        Button.</span
                      >
                    </v-tooltip>
                    <v-tooltip v-else right>
                      <template #activator="{ on }">
                        <v-icon v-on="on"> fas fa-badge-check </v-icon>
                      </template>
                      <span>
                        You need to finish watching
                        <strong>{{ series.user_progress.units_left }}</strong>
                        more video(s) to get certified in this series.</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <h2 :class="series.is_banner ? 'text-white' : ''">
                      {{ series.name }}
                    </h2>
                  </v-col>
                  <v-col cols="12" sm="12" md="1" lg="1" xl="1"> </v-col>
                </v-row>
                <router-link
                  v-if="series.is_banner"
                  :to="{
                    name: 'UnitPage',
                    params: { id: renderBanner(series).id },
                  }"
                >
                  <div v-if="series.is_banner" class="overlay"></div>
                </router-link>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- <v-btn outlined :color="isMobile ? 'white' : ''" class="pulsing" @click="toggleUploadUnitDialog(series)">
                        <v-icon  left small>fal fa-plus</v-icon>
                        Upload
                      </v-btn> -->

                <div class="row">
                  <draggable
                    :list="series.units"
                    :disabled="!isEdit"
                    @change="changeOrder"
                    @start="dragging = true"
                    @end="dragging = false"
                    class="row"
                    handle=".handle"
                    draggable=".item"
                    :options="{ animation: 200, group: 'status' }"
                    :element="'div'"
                    v-model="series.units"
                  >
                    <div
                      v-if="canEdit(module.company_id)"
                      slot="header"
                      class="col-md-6 col-lg-4"
                    >
                      <v-card class="mx-auto text-left">
                        <v-img
                          class="white--text unit-image"
                          src="https://webinarinc-v2-development.s3-us-west-2.amazonaws.com/categories/4/36168a56b2741b3b52045c4e0ea4165c.jpg"
                          min-height="200px"
                          max-height="280px"
                          gradient="to top right, rgba(0,0,0,.70), rgba(25,32,72,.7)"
                          @click="toggleUploadUnitDialog(series)"
                          aspect-ratio="1"
                        >
                          <v-card-title class="headline justify-center">
                            Upload Content
                          </v-card-title>
                        </v-img>
                      </v-card>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 handle item"
                      v-for="(unitSeries, index) in filteredUnits(series.units)"
                      :key="index"
                    >
                      <unit-card
                        :unit="unitSeries.unit"
                        :key="index"
                      ></unit-card>
                    </div>
                  </draggable>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </draggable>
        </v-expansion-panels>
      </v-card>
      <links
        :module-id="module.id"
        :is-loading="isLoading"
        :name="module.name"
        :module-links="module.links"
        :to-delete="toDelete"
        :show-links-dialog="showLinksDialog"
        :close-modal="toggleCloseLinks"
        :save-links="saveLinks"
      />
    </div>

    <v-snackbar :timeout="0" v-model="isEdit">
      You are in Edit Mode
      <v-spacer />
      <v-btn color="error" @click="toggleEditMode" x-small> Close </v-btn>
    </v-snackbar>

    <v-snackbar style="margin-bottom: 65px" :timeout="0" v-model="isChanged">
      <v-btn
        class="ma-auto"
        color="success"
        :disabled="isLoading"
        :loading="isLoading"
        @click="saveModuleChanges"
        small
        >Save Changes
      </v-btn>
      <v-btn
        class="ma-auto"
        color="primary"
        :disabled="isLoading"
        :loading="isLoading"
        small
        @click="undoChanges"
        >Undo Changes
      </v-btn>
    </v-snackbar>

    <add-series-dialog
      :module="module"
      :add-series-dialog="addSeriesDialog"
      :toggle-add-series-dialog="toggleAddSeriesDialog"
      v-on:series="getSeries"
      :closeModal="toggleClose"
    ></add-series-dialog>

    <edit-series-dialog
      :module="module"
      :series="selectedSeries"
      :edit-series-dialog="editSeriesDialog"
      :toggle-edit-series-dialog="toggleEditSeriesDialog"
      :key="key"
      :show-curriculum="showCurriculum"
      v-on:series="getSelectedSeries"
      :closeModal="toggleClose"
    ></edit-series-dialog>

    <confirm-delete-dialog
      :close-dialog="closeConfirmDialog"
      :confirm-action="proceedToDelete"
      :unpublished-action="proceedToDelete"
      :show-dialog="showConfirmDeleteDialog"
      :loading="loading.delete"
    >
      Are you sure you want to proceed?
    </confirm-delete-dialog>
    <loading-dialog
      :message="'Processing Request...'"
      :loading-dialog="downloadLoading"
    ></loading-dialog>
    <loading-dialog
      :message="'Uploading Thumbnail'"
      :loading-dialog="savingThumbnail"
    ></loading-dialog>
    <loading-dialog
      :message="createMessage"
      :loading-dialog="createLoading"
    ></loading-dialog>
    <confirm-dialog
      :close-dialog="toggleConfirmDialog"
      :confirm-action="undoChanges"
      :show-dialog="showConfirmDialog"
      :loading="isLoading"
    >
      Your changes are not yet saved do you want to proceed?
    </confirm-dialog>

    <upload-dialog
      :series-id="selectedSeries.id"
      :toggle-upload-dialog="toggleUploadDialog"
      :add-upload-dialog="addUploadDialog"
      v-on:unit="fetchAddedUnit"
      :close-dialog="toggleClose"
    >
    </upload-dialog>
    <upload-file-dialog
      :type="['image', 'video']"
      :show-upload-dialog="showUploadFileDialog"
      :upload-dialog="toggleUploadFileDialog"
      :close-dialog="toggleClose"
      v-on:showImage="getThumbnail"
    />
  </div>
</template>

<script>
import {
  each as _each,
  map as _map,
  filter as _filter,
  isEmpty as _isEmpty,
  includes as _includes,
  some as _some,
  forEach as _forEach,
  findIndex as _findIndex,
} from 'lodash-es';
import UnitCard from '@/components/client-lms/UnitCard';
import AssignModule from '../client-lms/dialog-box/AssignModule.vue';
import ShareModule from '../client-lms/dialog-box/ShareModule.vue';
import LoadingDialog from '@/components/course-certification/includes/LoadingDialog';
import AddSeriesDialog from '@/components/course-certification/includes/AddSeriesDialog';
import EditSeriesDialog from '@/components/course-certification/includes/EditSeriesDialog';
import draggable from 'vuedraggable';
import WordEditor from '@/components/WordEditor';
import ConfirmDeleteDialog from '@/components/dialogs/ConfirmDeleteDialog';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog';
import EventBus from '@/plugins/eventBus';
import Links from '@/components/course-certification/includes/Links';
import UploadDialog from '@/components/partials/_header/UploadDialog.vue';
import UploadFileDialog from '@/components/dialogs/UploadFileDialog';
export default {
  name: 'CertificateModulePage',
  components: {
    UnitCard,
    AssignModule,
    ShareModule,
    LoadingDialog,
    AddSeriesDialog,
    EditSeriesDialog,
    WordEditor,
    ConfirmDeleteDialog,
    ConfirmDialog,
    Links,
    UploadDialog,
    UploadFileDialog,
  },
  data() {
    return {
      createLoading: false,
      createMessage: 'Generating Blank...',
      savingThumbnail: false,
      showUploadFileDialog: false,
      showRelatedLinks: false,
      showLinksDialog: false,
      showConfirmDialog: false,
      defaultPanel: [0],
      search: '',
      includes: _includes,
      isEmpty: _isEmpty,
      imageFileTypes: ['jpg', 'png', 'webp'],
      moduleBuild: {},
      module: {
        series: [],
        links: [],
      },
      toDelete: [],
      loading: {
        fetch: true,
      },
      showShareModule: false,
      showAssignModule: false,
      downloadLoading: false,
      isEdit: false,
      isDraggable: false,
      addSeriesDialog: false,
      editSeriesDialog: false,
      selectedSeries: {
        module: {
          id: null,
          name: null,
          course: {
            id: null,
            curriculum_id: null,
          },
        },
      },
      isMoved: false,
      isChanged: false,
      orders: [],
      isLoading: false,
      selectedIdForDeletion: '',
      showConfirmDeleteDialog: false,
      key: 0,
      originalState: null,
      prevRoute: null,
      addUploadDialog: false,
      showCurriculum: false,
      breadCrumbsItems: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  created() {
    this.getModule();
    this.fetchUsers();
    EventBus.$on('refreshCourseCertification', () => {
      this.getModule();
    });
  },
  computed: {
    checkProgressChange() {
      return this.module.user_certificate && this.module.module_progress < 100;
    },
    user() {
      return this.$auth.user();
    },
    isAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },
    isManager() {
      return _some(this.$auth.user().roles, { name: 'account-manager' });
    },
    bannerUrl() {
      return this.fetchVideoId(this.module.thumbnail);
    },
  },
  methods: {
    generateBreadCrumbs(module) {
      this.breadCrumbsItems = [
        {
          disabled: false,
          to: {
            name: 'Home',
            query: {
              goToSection: 'curriculum_' + module.course.curriculum_id,
            },
          },
          text: module.course.curriculum.name + ' - Curriculum',
        },
        {
          disabled: false,
          to: {
            name: 'Course Page',
            params: {
              id: module.course_id,
            },
          },
          text: module.course.name + ' - Course',
        },
        {
          disabled: true,
          text: module.name + ' - Module',
        },
      ];
    },
    toggleUploadFileDialog() {
      this.showUploadFileDialog = true;
    },
    getThumbnail(item) {
      this.savingThumbnail = true;
      const payload = new FormData();
      payload.append('thumbnail', item.value);
      payload.append('id', this.module.id);
      this.axios
        .post('/client/lms/update/thumbnail/module', payload)
        .then(({ data }) => {
          this.module.thumbnail = data.thumbnail;
          this.$notify('success', 'Module Thumbnail Updated');
        })
        .catch()
        .finally(() => {
          this.savingThumbnail = false;
        });
    },
    fetchVideoId(url) {
      if (!url) {
        return;
      }
      if (url.includes('vimeo')) {
        const vimeoUrl =
          /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/.exec(
            url
          );
        const vimeoId = vimeoUrl[vimeoUrl.length - 1];
        return `https://player.vimeo.com/video/${vimeoId}`;
      }
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      const youtubeId = match && match[7].length == 11 ? match[7] : false;
      if (youtubeId) {
        return `https://www.youtube.com/embed/${youtubeId}`;
      }
      return url;
    },
    setLinksData() {
      const formData = new FormData();
      formData.append('module_id', this.module.id);
      if (this.toDelete.length > 0) {
        _forEach(_map(this.toDelete), (link, index) => {
          formData.append(`to_delete[${index}]]`, link.id);
        });
      }
      _forEach(_map(this.module.links), (link, index) => {
        if (link.url && link.name) {
          if (link.id) {
            formData.append(`links[${index}][id]`, link.id);
          }
          formData.append(`links[${index}][name]`, link.name);
          formData.append(`links[${index}][url]`, link.url);
        }
      });
      return formData;
    },
    saveLinks() {
      this.isLoading = true;
      const payload = this.setLinksData();
      this.axios
        .post('/client/lms/update/links/module', payload)
        .then(({ data }) => {
          this.module.links = data;
          this.showRelatedLinks = true;
          this.originalState = JSON.stringify(this.module);
          this.$notify('success', this.module.name + ' Links updated!');
        })
        .catch()
        .finally(() => {
          this.isLoading = false;
          this.showLinksDialog = false;
        });
    },
    toggleLinksDialog() {
      this.showLinksDialog = !this.showLinksDialog;
    },
    toggleConfirmDialog() {
      this.showConfirmDialog = !this.showConfirmDialog;
    },
    canEdit(company_id) {
      if (this.isAdmin) {
        return true;
      }
      if (this.isManager) {
        return this.user.dealer_id == company_id;
      }
    },
    downloadCertificate(series) {
      this.downloadLoading = true;
      let params = {
        id: series,
        type: 'series',
      };
      this.$http
        .post('/client/reports/lms/progress/download-certificate', params)
        .then((data) => {
          this.downloadLoading = false;
          window.open(data.data, '_blank');
        });
    },
    resendCertificate(series) {
      this.downloadLoading = true;
      let params = {
        id: series,
        type: 'series',
        userId: this.user.id,
      };
      this.$http
        .put('/client/reports/lms/progress/send-certificate', params)
        .then((data) => {
          this.downloadLoading = false;
          this.$notify('success', 'Send Certificate Successfully');
          console.log(data);
        });
    },
    fetchUsers() {
      this.$store
        .dispatch('lmsClient/fetchUsersByDealer')
        .then(({ data }) => {
          this.$store.dispatch('lmsClient/setUsers', data);
        })
        .catch(() => {
          console.log('error');
        });
    },
    toggleShowUnits(index) {
      this.module.series = this.module.series.map(function (
        series,
        seriesIndex
      ) {
        // eslint-disable-next-line no-param-reassign
        series.active = seriesIndex === index ? !series.active : false;
        return series;
      });
    },
    markAsWatched(id) {
      this.$http
        .post('/mark-intro-video-watched', {
          module_id: id,
        })
        .then((response) => {
          this.module.module.intro_video_watched = true;
          this.$notify('success', 'Successfully completed the video.');
        });
    },
    renderBanner(series) {
      if (!series.highlight_unit) {
        return series.units[0].unit;
      }
      let highlight = series.units.filter((unit) => {
        return unit.unit_id == series.highlight_unit;
      });
      return highlight[0].unit;
    },
    filteredUnits(series) {
      if (this.search) {
        return _filter(series, (unit) => {
          return unit.unit.name
            .toString()
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
      return series;
    },
    getModule() {
      this.loading.fetch = true;
      this.$http(
        `/client/lms/course-certifications/modules/${this.$route.params.id}`
      ).then(({ data }) => {
        this.module = data.data;
        this.module.series = this.module.series.map((series, index) => {
          series.active = index === 0;
          return series;
        });
        this.originalState = JSON.stringify(this.module);
        // this.module.series = [];
        this.$nextTick(() => {
          this.generateBreadCrumbs(data.data);
          this.loading.fetch = false;
        });
      });
    },
    toggleEditMode() {
      if (this.isChanged && this.isEdit) {
        this.showConfirmDialog = true;
      } else {
        this.isEdit = !this.isEdit;
        this.toggleClose();
        this.isChanged = false;
      }
    },
    toggleAddSeriesDialog() {
      // this.addSeriesDialog = !this.addSeriesDialog;
      this.storeSeries();
    },
    seriesData() {
      let module_id = this.module ? this.module.id : this.module_id;
      const form = new FormData();
      form.append('name', 'Blank');
      form.append('module_id', module_id);
      form.append('is_draft', false);
      return form;
    },
    storeSeries() {
      this.createMessage = 'Generating Series...';
      this.createLoading = true;
      this.$validator.validate('*').then((result) => {
        if (result) {
          this.$http
            .post('client/lms/series', this.seriesData())
            .then((data) => {
              this.$emit('series', data.data);
              this.module.series.unshift(data.data);
              this.$notify('success', 'Series saved!');
              this.createLoading = false;
            })
            .catch((error) => {
              this.interactWithErrorBag(error, this.errors);
            })
            .finally((data) => {
              this.createLoading = false;
              this.close();
            });
        } else {
          this.createLoading = false;
        }
      });
    },
    fetchAddedUnit(item) {
      const index = _findIndex(this.module.series, {
        id: parseInt(this.selectedSeries.id),
      });
      this.module.series[index].units.unshift(item);
      this.forceRerender();
    },
    editSeries(item) {
      this.selectedSeries = item;
      this.forceRerender();
      this.editSeriesDialog = !this.editSeriesDialog;
    },
    deleteSeries(item) {
      this.selectedIdForDeletion = item.id;
      this.selectedSeries = item;
      this.showConfirmDeleteDialog = true;
    },
    closeConfirmDialog() {
      this.showConfirmDeleteDialog = false;
      this.loading.delete = false;
    },
    proceedToDelete() {
      this.loading.delete = true;
      this.axios
        .delete(`/client/lms/series/${this.selectedIdForDeletion}`)
        .then((data) => {
          this.$notify('success', 'Series removed!');
          this.module.series.splice(
            this.module.series.indexOf(this.selectedSeries),
            1
          );
          this.closeConfirmDialog();
        });
    },
    toggleEditSeriesDialog() {
      this.editSeriesDialog = !this.editSeriesDialog;
    },
    toggleUploadDialog() {
      this.addUploadDialog = true;
    },
    toggleUploadUnitDialog(series) {
      this.toggleUploadDialog();
      this.selectedSeries = series;
    },
    checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
      this.isMoved = true;
    },
    changeOrder(e) {
      this.isChanged = true;
      this.orders = {
        id: this.module.id,
        name: this.module.name,
        description: this.module.description,
        series: [],
      };
      _each(this.module.series, (series) => {
        let newSeries = {
          id: series.id,
          units: _map(series.units, 'id'),
        };
        this.orders.series.push(newSeries);
      });
      console.log(this.orders);
    },
    undoChanges() {
      this.isLoading = true;
      const ogState = JSON.parse(this.originalState);
      this.axios
        .post('/client/lms/courseCertification/updateSeries', {
          data: ogState,
          is_save: false,
        })
        .then(({ data }) => {
          this.module = ogState;
          this.originalState = JSON.stringify(this.module);
          this.$notify('success', 'Successfully updated!');
        })
        .catch()
        .finally(() => {
          this.isLoading = false;
          this.isChanged = false;
          this.toggleClose();
        });
    },
    saveModuleChanges() {
      this.isLoading = true;
      this.axios
        .post('/client/lms/courseCertification/updateSeries', {
          data: this.module,
          is_save: true,
        })
        .then(({ data }) => {
          console.log(data);
          this.$notify('success', 'Successfully updated!');
        })
        .catch()
        .finally(() => {
          this.isLoading = false;
          this.isChanged = false;
          this.toggleClose();
        });
    },
    getSeries(item) {
      this.addSeriesDialog = false;
      this.editSeriesDialog = false;
      this.module.series.push(item);
    },
    getSelectedSeries(item) {
      this.addSeriesDialog = false;
      this.editSeriesDialog = false;
    },
    toggleClose() {
      this.addSeriesDialog = false;
      this.editSeriesDialog = false;
      this.showConfirmDialog = false;
      this.showLinksDialog = false;
      this.addUploadDialog = false;
      this.showUploadFileDialog = false;
    },
    toggleCloseLinks() {
      this.module.links = JSON.parse(this.originalState).links;
      this.showLinksDialog = false;
    },
    forceRerender() {
      this.key += 1;
    },
    goBack() {
      this.$router.push(this.prevRoute.path);
    },
  },
};
</script>
<style scoped>
.text-webinarinc {
  color: #f9b417;
}
.abs {
  z-index: 10;
  position: absolute;
}
.overlay {
  position: absolute; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>

<style scoped>
.edit-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.border-webi {
  border: #f9b418 1px dashed;
}
.pulsing:hover,
.pulsing-active {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  animation: pulse-black 1.2s infinite;
}
.addSeries {
  background-color: white;
}
/* Animation */
@keyframes pulse-black {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 180, 23 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(249, 180, 23 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 180, 23 0);
  }
}
</style>
